<app-mas-garantia-header></app-mas-garantia-header>
<app-mas-garantia-navbar>
    <app-banner></app-banner>
    <div class="contrainer grey px-2 px-lg-5 d-flex justify-content-center flex-column pb-5">
        <div class="text-center my-4 my-md-5 fs-3">
            <p class="m-0"> {{ 'MAS_GARANTIA.LABEL1' | translate }} </p>
        </div>
        
        <app-warranty-info></app-warranty-info>
    
        <div class="text-center my-4 my-md-5 fs-3">
            <p class="m-0"> {{ 'MAS_GARANTIA.LABEL2' | translate }} </p>
        </div>
    
            <app-warranty-coverage *ngIf="items" [items]="items"></app-warranty-coverage>
    
        <div class="text-center my-4 my-md-5 fs-3">
            <p class="m-0"> {{ 'MAS_GARANTIA.LABEL3' | translate }} </p>
        </div>
    
        <app-item-failure></app-item-failure>
    
        <div class="text-center my-4 my-md-5 fs-3">
            <p class="m-0"> {{ 'MAS_GARANTIA.LABEL4' | translate }} </p>
        </div>  
        
        <app-faqs *ngIf="questions" [questions]="questions"></app-faqs>

        <div class="text-center my-4 my-md-5 fs-3">
            <p class="m-0"> {{ 'MAS_GARANTIA.LABEL5' | translate }} </p>
        </div>  

        <div class="row gx-5 m-0 p-0">
            <div class="col-12 mb-4 px-0">
                <div class="h-100 px-4 px-md-5 flex aling-items-center white rounded shadow-sm">
                    <div class="row py-4 h-100 m-0 p-0">
                        <div class="col-12 m-0 p-0 d-flex flex-column justify-content-center">
                            <p class="mb-lg-2 mb-xl-4 text-center">
                                {{ 'MAS_GARANTIA.LABEL6' | translate }} 
                            </p>
                            <div *ngIf="!isMobile" class="d-flex mt-lg-1 mt-xl-3 justify-content-center">
                                
                                <a href="../../../assets/themes/liverpool/files/Clausulado_Más_Garantía.pdf" download="Clausulado_Más_Garantía">
                                    <button class="btn-w btn-h primary-bg-color" mat-flat-button color="accent"> {{ 'MAS_GARANTIA.LABEL7' | translate }} </button>
                                </a>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="isMobile" class="mt-4 w-100 px-0">

                <a href="../../../assets/themes/liverpool/files/Clausulado_Más_Garantía.pdf" download="Clausulado_Más_Garantía">
                    <button class="primary-bg-color w-100 btn-h" mat-flat-button color="accent"> {{ 'MAS_GARANTIA.LABEL7' | translate }} </button>
                </a>
                
            </div>
        </div>
    
    </div>
</app-mas-garantia-navbar>
<app-mas-garantia-footer></app-mas-garantia-footer>